module.exports = __webpack_public_path__ + "static/media/lc.d9f40d0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/lc.png
// module id = 1906
// module chunks = 0